import {Button, Form, InputGroup, Nav, Table} from "react-bootstrap";
import {Link} from "react-router-dom";
import {formatDate, getAdvancedSearch} from "../../Services/ApiService";
import {none, useState} from "@hookstate/core";

import './AdvancedSearch.scss';
import React from "react";

function AdvancedSearch() {
    const searchResults = useState([]);
    const startDate = useState('');
    const endDate = useState('');
    const isEstimateChecked = useState(false);

    // <editor-fold desc="Search">
    const searchTypes = {
        // all: 'All',
        jobNumber: 'Job Number',
        customerPO: 'Customer PO',
        clientName: 'Client',
        quantity: 'Quantity',
        itemInfo: 'Job Title',
        pressId: 'Press',
        outsideServices: 'Outside Service Vendor'
    }

    const searchTypesArray = [
        // {key: 'all', value: 'All'},
        {key: 'jobNumber', value: 'Job Number'},
        {key: 'customerPO', value: 'Customer PO'},
        {key: 'clientName', value: 'Client'},
        {key: 'quantity', value: 'Quantity'},
        {key: 'itemInfo', value: 'Job Title'},
        {key: 'pressId', value: 'Press'},
        {key: 'outsideServices', value: 'Outside Service Vendor'}
    ]

    const searches = useState([{type: 'itemInfo', searchQuery: '', modifier: ''}]);

    function addSearch() {
        searches[searches.get().length].set({type: 'itemInfo', searchQuery: '', modifier: ''});
    }

    function handleTypeSelectChange(e, idx) {
        searches[idx].modifier.set('')
        searches[idx].type.set(e.target.value)
    }

    function searchDiv(idx) {
        return <InputGroup>
            <select
                className={`searchSelect`}
                value={searches[idx].get().type}
                onChange={e => handleTypeSelectChange(e, idx)}
            >
                {searchTypesArray.map(type => {
                    return <option key={type.key} value={type.key}>{type.value}</option>
                })}
            </select>

            {searches[idx].get().type === "quantity" && (
                <select
                    className={`searchSelect`}
                    value={searches[idx].get().modifier}
                    onChange={e => searches[idx].modifier.set(e.target.value)}
                >
                    <option value={"="}>{'='}</option>
                    <option value={">"}>{'>'}</option>
                    <option value={"<"}>{'<'}</option>
                </select>
            )}

            <Form.Control
                id='searchInput'
                name='searchInput'
                autoComplete={'off'}
                value={searches[idx].get().searchQuery}
                onChange={e => searches[idx].searchQuery.set(e.target.value)}
            />
        </InputGroup>
    }

    function onFormSubmit(e) {
        e.preventDefault();

        //     if (!(searches.get().length === 1 && searches.get()[0].searchQuery === ''
        //         && startDate.get() === '' && endDate.get() === '')) {
        //         getAdvancedSearch({
        //             "searches": searches.get(),
        //             "startDate": startDate.get(),
        //             "endDate": endDate.get()
        //         });
        //     }
        // }
        if (!(searches.get().length === 1 && searches.get()[0].searchQuery === ''
            && startDate.get() === '' && endDate.get() === '')) {
            getAdvancedSearch({
                searches: (searches.get()),
                startDate: startDate.get(),
                endDate: endDate.get(),
                isEstimate: isEstimateChecked.get()
            }, _jobs => {
                searchResults.set(_jobs);
            });
        }
    }

    function handleClearClicked() {
        searches.set([{type: searchTypes.jobNumber, searchQuery: '', modifier: ''}]);
        startDate.set('');
        endDate.set('');
        isEstimateChecked.set(false);
        searchResults.set([]);
    }
    // </editor-fold desc="Search">

    return <div id={'advancedSearch'}>
        <Form onSubmit={onFormSubmit}>
            <div id={'searches'}>
                {searches.get().map((search, idx) => {
                    return <div key={idx} className={'search'}>
                        {searchDiv(idx)}
                        <div className={'buttons'}>
                            <Button type={'button'} onClick={() => addSearch()}>+</Button>
                            <Button type={'button'} onClick={() => searches[idx].set(none)}
                                    disabled={searches.get().length < 2} >-</Button>
                        </div>
                    </div>
                })}
            </div>

            <div id={'dateRangeDiv'}>
                    <InputGroup>
                        <div className={'dates'}>
                            <p>Start Date</p>
                            <Form.Control
                                type={'date'}
                                id='startDate'
                                name='startDate'
                                autoComplete={'off'}
                                value={startDate.get()}
                                onChange={e => startDate.set(e.target.value)}
                            />
                        </div>
                        <div className={'dates'}>
                            <p>End Date</p>
                            <Form.Control
                                type={'date'}
                                id='endDate'
                                name='endDate'
                                autoComplete={'off'}
                                value={endDate.get()}
                                onChange={e => endDate.set(e.target.value)}
                            />
                        </div>
                        <div id={'estimateCheck'}>
                            <Form.Check
                                id={'searchEstimatesCheck'}
                                label={"Search Estimates"}
                                checked={isEstimateChecked.get()}
                                onChange={e => isEstimateChecked.set(e.target.checked)}
                            />
                        </div>
                </InputGroup>
            </div>
            <div id={'submitButtonDiv'}>
                <Button type={'button'} id={'clear'} onClick={() => handleClearClicked()}>Clear</Button>
                <Button type={'submit'} id={'submit'}>Search</Button>
            </div>
        </Form>

        <Table id='list' bordered size={'sm'}>
            <thead>
            <tr>
                <th id={'jobNumberCol'}>Job Number</th>
                <th id={'clientCol'}>Client</th>
                <th id={'quantityCol'}>Quantity</th>
                <th id={'itemsCol'}>Job Items</th>
                <th id={'dateCol'}>Date Created</th>
                <th id={'statusCol'}>Status</th>
                <th id={'invoicedDateCol'}>Invoiced</th>
            </tr>
            </thead>
            <tbody>
            {searchResults.get().map((job, idx) => {
                // noinspection JSUnresolvedReference,JSValidateTypes
                return (
                    <tr key={idx}>
                        <td id={'number'}>
                            <Nav.Link as={Link} to={`/job/${job.id}`}>
                                {job.jobNumber !== -1 ? job.jobNumber + job.jobNumberAppend : "Estimate"}
                            </Nav.Link>
                        </td>
                        <td id={'client'}>
                            <Nav.Link as={Link} to={`/client/${job.clientId}`}>
                                {job.clientName}
                            </Nav.Link>
                        </td>
                        <td id={'quantity'}>{job.quantity}</td>
                        <td id={'itemInfo'}>
                            <Nav.Link as={Link} to={`/job/${job.id}`} className={'noBlue'}>
                                {job.itemInfo}
                            </Nav.Link>
                        </td>
                        <td id={'dateDue'}>{formatDate(job.dateReceived)}</td>
                        <td id={'status'}>{job.status}</td>
                        <td id={'invoicedDate'}>{formatDate(job.invoicedDate)}</td>
                    </tr>
                )
            })}
            </tbody>
        </Table>
    </div>
}

export default AdvancedSearch;